import CommentView from "./CommentView";

export default CommentView;
